// Walks the job with the core's own filter, so deleted frames drop out and the order is ascending.
export async function visibleFrames(job: {
    startFrame: number;
    stopFrame: number;
    frames: { search(filters: { notDeleted: boolean }, from: number, to: number): Promise<number | null> };
}): Promise<number[]> {
    const result: number[] = [];
    let from = job.startFrame;
    while (from <= job.stopFrame) {
        // eslint-disable-next-line no-await-in-loop
        const frame = await job.frames.search({ notDeleted: true }, from, job.stopFrame);
        if (frame === null) break;
        result.push(frame);
        from = frame + 1;
    }
    return result;
}
